import React from "react";
import ModalWindow from "../Shared/ModalWindow";

export default class ManualOverrideModal extends React.Component {

    constructor (props) {

        super(props);
        this.state = {
            "commentEdit": ""
        };

    }

    handleOnChangeText (event) {

        this.setState({
            "commentEdit": event.target.value
        });

    }

    handleOnClickCancel () {

        this.setState({"commentEdit": ""});

    }


    render () {

        let comment = this.state.commentEdit;
        let text = this.props.pageText.stockOrderAddManualOverrideModalText1;

        text = text.replace(
            "%%PARTNUMBER%%",
            this.props.partNumber
        );

        const confirmBody =
            (<div className= "text-left">
                <p>{text}</p>
                <p className="mb-0">{this.props.pageText.stockOrderAddManualOverrideModalText2}</p>
                <p>{this.props.pageText.stockOrderAddManualOverrideModalText3}</p>
                <p>{this.props.pageText.stockOrderAddManualOverrideModalText4}</p>

                {this.props.isLastItem && (
                    <div className="alert alert-warning mt-3 mb-3 text-left">
                        {this.props.pageText.stockOrderAddManualOverrideModalText5}
                    </div>
                )}
                <textarea className="form-control" value={comment} placeholder="Add a Comment" onChange={(e) => this.handleOnChangeText(e)} />
                <button className="btn btn-danger modalButton" data-dismiss="modal" onClick={() => this.props.onClickSave(comment)}>{this.props.pageText.stockOrderAddManualOverrideModalAddBtn}</button>
                <button className="btn btn btn-secondary modalButton" data-dismiss="modal" href={"#" + this.props.modalId} onClick={() => this.handleOnClickCancel()}>{this.props.pageText.stockOrderAddManualOverrideModalCancelBtn}</button>
            </div>);

        return (
            <ModalWindow
                modalBody={confirmBody}
                modalId={this.props.modalId}
                modalTitle={this.props.modalTitle}
                onModalClose={() => this.handleOnClickCancel()}
            />
        );

    }

}
